export const EXPLORED_TABLES_EVENT = 'tmt:table-explored';

export const exploredTablesKey = (projectId: string): string => `tmt_explored_table_${projectId}`;

export function markTablesExplored(projectId: string): void {
  try {
    if (localStorage.getItem(exploredTablesKey(projectId)) === '1') return;
    localStorage.setItem(exploredTablesKey(projectId), '1');
  } catch {
    return;
  }
  globalThis.dispatchEvent(new Event(EXPLORED_TABLES_EVENT));
}

export function hasExploredTables(projectId: string): boolean {
  try {
    return projectId !== '' && localStorage.getItem(exploredTablesKey(projectId)) === '1';
  } catch {
    return false;
  }
}
